import { EMPTY_OBJECT, EMPTY_STRING } from '../../../constants/common'
import { ROLE_TRANSLATION_ALIASES } from '../../../constants/user'
import { isAITextGenerationLocalContextTypeServiceRequestEmail } from '../../AITextGeneration'

export function getEmailProfileMessageParticipantName(
  { role, ...restProps },
  { nameKey = 'fullname', t, withRole } = EMPTY_OBJECT
) {
  const name = restProps[nameKey]

  return name
    ? name +
        (role && withRole && t
          ? ` | ${t(ROLE_TRANSLATION_ALIASES[role])}`
          : EMPTY_STRING)
    : EMPTY_STRING
}

// The generate endpoint accepts email_uuid only for service_request_email (400 otherwise)
export function getEmailProfileMessageAiLocalContext({
  messageUuid,
  objectId,
  type,
}) {
  const localContext = { object_id: String(objectId), type }

  if (
    messageUuid &&
    isAITextGenerationLocalContextTypeServiceRequestEmail(type)
  ) {
    localContext.email_uuid = String(messageUuid)
  }

  return localContext
}
